import React from 'react';
import { Field, reduxForm, formValueSelector, initialize } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox } from '../../../common/components/formControls';
import { withTranslation } from 'react-i18next';

const QuerySettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, filters, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			<Field name='name' component={Input} horizontal required disabled={isReadonly} type='text' placeholder={`${t('SavedQuery_Name')} *`} labelCol={0} valueCol={12} />
			{filters && Object.keys(filters).map((x) => (
				<Field key={`filter_${x}`} name={x} component={Checkbox} disabled={isReadonly} horizontal label={filters[x].label} normalize={v => !!v} labelCol={0} valueCol={12} />
			))}
			<Button type='submit' bsStyle='success' disabled={submitting} className='pull-right'>{t('Common_Save')}</Button>
		</Form>
	);
};

export default reduxForm({ form: 'savedQuery', enableReinitialize: true })(withTranslation()(QuerySettingsForm));

export const selector = formValueSelector('savedQuery');
export const initializeForm = (data, fields) => initialize('savedQuery', data, fields);
